import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, withKeys as _withKeys, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["title", ".open"]
const _hoisted_2 = {
  id: "modal-container-element",
  class: "modal-content"
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 2,
  class: "local"
}
const _hoisted_6 = ["value", "label"]
const _hoisted_7 = ["value", "label"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = {
  key: 3,
  class: "mt-20 text-center"
}
const _hoisted_10 = ["disabled"]
const _hoisted_11 = {
  key: 4,
  class: "mt-20 text-center"
}
const _hoisted_12 = ["disabled"]

import axios from 'axios';
import { useStore } from 'vuex';
import { ref, watchEffect } from 'vue';

import epinioAuth, { EpinioAuthTypes } from '../utils/auth';
import { stringify, exceptionToErrorsArray } from '@shell/utils/error';
import { EpinioCluster } from '../models/cluster';

import { Banner } from '@components/Banner';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginDialog',
  emits: ["close"],
  setup(__props, { expose: __expose, emit: __emit }) {

const store = useStore();

const emit = __emit;

const PROVIDER_TYPES = {
  LOCAL: 'local',
  DEX:   'dex',
};

const username = ref<string>('');
const password = ref<string>('');
const selectedAuthType = ref<string>('');
const busy = ref<boolean>(false);
const showModal = ref<boolean>(false);
const cluster = ref<EpinioCluster | null>(null);

let errors: Error[] = [];
let selectedTab: string;

watchEffect(() => {
  if (!cluster.value?.oidcEnabled) {
    selectedAuthType.value = PROVIDER_TYPES.LOCAL;
  } else {
    selectedAuthType.value = PROVIDER_TYPES.DEX;
  }
});

const selectType = (type: string) => {
  errors = [];
  selectedAuthType.value = type as string;
}

const login = async (provider: string) => {
  busy.value = true;
  errors = [];

  try {
    switch (provider) {
      case PROVIDER_TYPES.LOCAL:
        if (!username.value) {
          errors.push(new Error('Username'));
        }
        if (!password.value) {
          errors.push(new Error('Password'));
        }
        if (errors.length) {
          throw new Error(`${ errors.join('/') } Required`);
        }

        await epinioAuth.login(cluster.value!.createAuthConfig(
          EpinioAuthTypes.LOCAL, {
            username: username.value,
            password: password.value,
            $axios:   axios,
          }
        ));
        break;
      case PROVIDER_TYPES.DEX:
        await epinioAuth.login(cluster.value!.createAuthConfig(EpinioAuthTypes.DEX));
        break;
      default:
        throw new Error(`Unknown log in type: ${ selectedTab }`);
    }
    cluster.value!.loggedIn = true;

    //Ensure the store knows the dialog has been closed.
    emit('close');

    store.$router.push({
      name:   'epinio-c-cluster-dashboard',
      params: { cluster: cluster.value!.id }
    });
  } catch (err) {
    errors.push(...exceptionToErrorsArray(err));
  }

  busy.value = false;
}

const openLogin = (selectedCluster: EpinioCluster) => {
  showModal.value = true;
  cluster.value = selectedCluster;
}

const closeLogin = () => {
  showModal.value = false;
  cluster.value = null;
  username.value = '';
  password.value = '';
  busy.value = false;
  errors = [];
};

__expose({
  openLogin,
  closeLogin,
});

return (_ctx: any,_cache: any) => {
  return (!!cluster.value)
    ? (_openBlock(), _createElementBlock("trailhand-modal", {
        key: 0,
        title: `Login ${ cluster.value.name ? `to ${ cluster.value.name }` : '' }`,
        ".open": showModal.value,
        onModalClose: closeLogin
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_unref(errors).length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(errors), (err, idx) => {
                  return (_openBlock(), _createElementBlock("div", { key: idx }, [
                    _createVNode(_unref(Banner), {
                      color: "error",
                      label: _unref(stringify)(err.Message || err)
                    }, null, 8, ["label"])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _cache[12] || (_cache[12] = _createTextVNode()),
          (selectedAuthType.value == PROVIDER_TYPES.DEX)
            ? (_openBlock(), _createElementBlock("trailhand-button", {
                key: 1,
                disabled: busy.value,
                size: "medium",
                onButtonClick: _cache[0] || (_cache[0] = ($event: any) => (!busy.value && login(PROVIDER_TYPES.DEX))),
                onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(($event: any) => (!busy.value && login(PROVIDER_TYPES.DEX)), ["prevent"]), ["enter"]))
              }, _toDisplayString(_ctx.t('epinio.login.genericProvider')), 41, _hoisted_4))
            : _createCommentVNode("", true),
          _cache[13] || (_cache[13] = _createTextVNode()),
          (selectedAuthType.value === PROVIDER_TYPES.LOCAL)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("form", {
                  class: "login-form",
                  onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (!busy.value && login(PROVIDER_TYPES.LOCAL)), ["prevent"]))
                }, [
                  _createElementVNode("trailhand-text-input", {
                    id: "username",
                    value: username.value,
                    label: _ctx.t('login.username'),
                    required: true,
                    size: "large",
                    style: {"width":"100%"},
                    onTextInputChange: _cache[2] || (_cache[2] = (e) => username.value = e.detail.value)
                  }, null, 40, _hoisted_6),
                  _cache[10] || (_cache[10] = _createTextVNode()),
                  _createElementVNode("trailhand-text-input", {
                    id: "password",
                    value: password.value,
                    label: _ctx.t('login.password'),
                    required: true,
                    size: "large",
                    style: {"width":"100%"},
                    type: "password",
                    onTextInputChange: _cache[3] || (_cache[3] = (e) => password.value = e.detail.value)
                  }, null, 40, _hoisted_7),
                  _cache[11] || (_cache[11] = _createTextVNode()),
                  _createElementVNode("trailhand-button", {
                    size: "medium",
                    disabled: busy.value,
                    type: "submit",
                    onKeydown: _cache[4] || (_cache[4] = _withKeys(_withModifiers(($event: any) => (!busy.value && login(PROVIDER_TYPES.LOCAL)), ["prevent"]), ["enter"]))
                  }, _toDisplayString(_ctx.t(cluster.value.oidcEnabled ? 'login.loginWithLocal' : 'epinio.login.login')), 41, _hoisted_8)
                ], 32)
              ]))
            : _createCommentVNode("", true),
          _cache[14] || (_cache[14] = _createTextVNode()),
          (selectedAuthType.value === PROVIDER_TYPES.DEX)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("trailhand-button", {
                  variant: "secondary",
                  size: "medium",
                  disabled: busy.value,
                  type: "button",
                  onButtonClick: _cache[6] || (_cache[6] = ($event: any) => (!busy.value && selectType(PROVIDER_TYPES.LOCAL))),
                  onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (!busy.value && selectType(PROVIDER_TYPES.LOCAL)), ["prevent"]), ["enter"]))
                }, _toDisplayString(_ctx.t('login.useLocal')), 41, _hoisted_10)
              ]))
            : _createCommentVNode("", true),
          _cache[15] || (_cache[15] = _createTextVNode()),
          (cluster.value.oidcEnabled && selectedAuthType.value === PROVIDER_TYPES.LOCAL)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("trailhand-button", {
                  variant: "secondary",
                  size: "small",
                  disabled: busy.value,
                  type: "button",
                  onButtonClick: _cache[8] || (_cache[8] = ($event: any) => (!busy.value && selectType(PROVIDER_TYPES.DEX))),
                  onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(($event: any) => (!busy.value && selectType(PROVIDER_TYPES.DEX)), ["prevent"]), ["enter"]))
                }, _toDisplayString(_ctx.t('epinio.login.useGenericProvider', {})), 41, _hoisted_12)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 40, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})